export const environment = {
  production: true,
  apiEndpoint: 'https://dev.account.realwell.org.au'
};
